export const testAttributes = {
    BOX_ERROR_CONTAINER: 'box_error_container',
    BOX_ERROR_BUTTON: 'box_error_button',
}